module.exports = __webpack_public_path__ + "img/Certop_TR_ISO_IEC_27001_ISO_IEC_27018_hun.9d0e8192.jpg";